import { h } from 'preact'
import logoJo2024 from './logo-paris-2024-orange_180.png'

export const JoCountdown = ({ countdown, text, URL, analytics }) => {
   return (
      <div class="jo-countdown container-fluid">
         <a
            href={URL}
            class="wrapper"
            title="Découvrez les Jeux Olympiques avec Orange"
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <img src={logoJo2024} alt="Paris 2024, Orange Partenaire Premium" loading="lazy" />
            <p>
               <span class="countdown">
                  <span aria-label="J moins">J-</span>
                  {countdown}
               </span>
               {text}
            </p>
         </a>
      </div>
   )
}
